<template>
  <div class="All">
    <div class="link-list">
      <div v-for="(item, index) in formList" :key="item.id" :class="{ activeColor: colorIndex === index }" @mouseover="changeColor(item, index)" @click="itemBtn(item,index)">
        {{ item.name }}
      </div>
    </div>
    <div v-for="(item, index) in formList" :key="index">
      <div class="link-list-detail link-list" v-if="item.sons.length!==0&&index===idx">
        <div class="city-title">{{ formList[idx].name }}</div>
        <div v-for="(subitem,subindex) in item.sons" :key="subitem.id" @click="subitemBtn(subitem)" :class="{ activeColor: subcolorIndex === subindex }" @mouseover="subchangeColor(subindex)">
          {{ subitem.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formList:{
      type:Array
    }
  },
  data() {
    return {
      colorIndex: -1,
      idx: 0,
      subcolorIndex:null
    };
  },
  methods: {
    changeColor(item, index) {
      this.colorIndex = index;
    },
    subchangeColor(index) {
      this.subcolorIndex = index;
    },
    // 点击一级时触发的函数
    itemBtn(item,index){
      if(item.sons.length!==0){
        // 有二级
        this.idx = index;
      }else{
        // 没有二级
        // window.location.href=item.url
        window.open(item.url)
      }
    },
    // 点击二级触发的函数
    subitemBtn(item){
      // window.location.href=item.address
      window.open(item.address)
    }
  },
};
</script>
  
  <style lang="less" scoped>
.link-list {
  width: 100%;
  padding-top: 8px;
  min-height: 60px;
  font-size: 1em;
  padding-bottom: 30px;
  div {
    padding-right: 23px;
    display: block;
    height: 30px;
    line-height: 30px;
    float: left;
    margin-right: 25px;
    text-indent: 26px;
    text-decoration: none;
    color: black;
    cursor: pointer;
    background: url(../assets/image/bit1.jpg) left center no-repeat;
  }
  .activeColor {
    // background-color: #c10005;
    color:red;
  }
}

.link-list-detail {
  border-top: 1px dashed #edebea;
  div {
    background: url(../assets/image/bit1.jpg) left center no-repeat;
  }

  .city-title {
    width: 98%;
    margin-right: 2%;
    margin-bottom: 10px;
    font-weight: bold;
    background: url(../assets/image/bit1.jpg) left center no-repeat;
  }
}
// 没有孩子的孩子的样式
// .link-list{
//     width: 100%;
//     padding-top: 8px;
//     font-size: 1em;
//     padding-bottom: 30px;
//      div{
//         display: block;
//         height: 30px;
//         line-height: 30px;
//         float: left;
//         margin-right: 40px;
//         background: url(../assets/image/bit1.jpg) left center no-repeat;
//         text-indent: 26px;
//         text-decoration: none;
//         color: black;
//     } 
// }
</style>